<template>
  <div class="container-fluid login_page main_style">
    <navbar />
    <b-row style="margin-top: 131px">
      <b-col
        xl="3"
        offset-xl="4"
        lg="3"
        offset-lg="2"
        md="3"
        offset-md="2"
        sm="3"
        offset-sm="1"
        style="text-align: left"
      >
        <b-button
          @click="goBack"
          style="background-color: transparent; color: #333333; border: none"
        >
          <b-icon-arrow-left-circle></b-icon-arrow-left-circle>
          กลับสู่หน้าหลัก
        </b-button>
      </b-col>
      <b-col cols="12">
        <div class="rectangle_login">
          <b-row>
            <b-col
              class="text-center"
              cols="4"
              lg="2"
              md="2"
              offset="4"
              offset-lg="5"
              offset-md="5"
              offset-sm="5"
              offset-xl="5"
              sm="2"
              xl="2"
            >
              <p
                class="m-0"
                style="font-size: 24px; font-weight: bolder; text-align: left"
              >
                LOGIN
              </p>
              <p style="font-size: 13px; font-style: normal; text-align: right">
                เข้าสู่ระบบ
              </p>
            </b-col>
          </b-row>
          <b-form @keyup.enter="Login">
            <b-row class="mt-3 mx-5">
              <b-col class="text-center">
                <b-form-input
                  v-model="email"
                  class="input_text"
                  placeholder="ชื่อผู้ใช้งาน"
                  type="text"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mt-3 mx-5">
              <b-col class="text-center">
                <b-form-input
                  v-model="password"
                  class="input_text"
                  placeholder="รหัสผ่าน"
                  type="password"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-form>
          <b-row class="justify-content-end">
            <b-col cols="6"
              ><small @click="toForgetPage" class="forget-text pointer"
                >ลืมรหัสผ่าน?</small
              ></b-col
            >
          </b-row>
          <b-row>
            <b-col
              class="text-center"
              cols="8"
              offset="2"
              lg="6"
              md="6"
              offset-lg="3"
              offset-md="3"
              offset-sm="3"
              offset-xl="3"
              sm="6"
              xl="6"
            >
              <b-button
                @click="Login"
                class="text-center my-4 py-3 btn-login btn btn-block"
              >
                เข้าสู่ระบบ
              </b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <hr />
            </b-col>
            <b-col cols="4"> หรือเข้าใช้งานด้วย </b-col>
            <b-col cols="4">
              <hr />
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-center" cols="12">
              <b-button
                @click="socialGoogleLogin"
                class="text-center btn-block my-4 pill btn btn-google-login btn-block outline-secondar"
              >
                <img :src="require(`../assets/images/logo/google.png`)" />
                เข้าสู่ระบบด้วย Google
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import firebase from "firebase";
import { mapState } from "vuex";
import navbar from "@/components/navbar";
import Swal from "sweetalert2";

export default {
  name: "LoginPage",
  data() {
    return {
      email: "",
      password: "",
      googleData: {
        id: "",
        first_name: "",
        last_name: "",
        email: "",
      },
    };
  },
  components: {
    navbar,
  },
  mounted() {
    this.checkLogin();
  },
  computed: {
    ...mapState({
      accessToken: (state) => state.AuthModule.accessToken,
    }),
  },
  methods: {
    checkLogin() {
      if (this.accessToken) {
        let path = "/";
        if (this.$route.path !== path) this.$router.push(path);
      } else {
        let path = "/login";
        if (this.$route.path !== path) this.$router.push(path);
      }
    },
    toForgetPage() {
      this.$router.push("forgetPassword");
    },
    goBack() {
      const path = `/`;
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    Login() {
      let data = {
        email: this.email ? this.email : null,
        password: this.password ? this.password : null,
      };
      if (data.email && data.password) {
        Swal.fire({
          title: "ระบบกำลังทำงาน",
          html: "โปรดรอสักครู่...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
            // this.$store.dispatch("AuthModule/setLogin", data);
            this.$store.dispatch("AuthModule/onLogin", data).then((res) => {
              if (res && res.code == 200) {
                Swal.fire({
                  title: "เข้าสู่ระบบสำเร็จ",
                  allowEscapeKey: true,
                  allowOutsideClick: true,
                });
                let path = "/pdpa";
                if (this.$route.path !== path) this.$router.push(path);
              } else {
                Swal.fire({
                  title: "เข้าสู่ระบบผิดพลาด",
                  icon: "error",
                });
                let path = "/login";
                if (this.$route.path !== path) {
                  this.$router.push(path);
                } else {
                  window.location.reload();
                }
              }
            });
          },
        });
      }
    },
    socialGoogleLogin() {
      const provide = new firebase.auth.GoogleAuthProvider().addScope("email");
      let self = this;
      firebase
        .auth()
        .signInWithPopup(provide)
        .then((result) => {
          // create user in db
          let obj = {
            google_id: result.additionalUserInfo.profile.id,
            email: result.additionalUserInfo.profile.email,
          };
          self.googleLogin(obj);
        })
        .catch((err) => {
          alert("Oops. " + err.message);
        });
    },
    googleLogin(obj) {
      Swal.fire({
        title: "ระบบกำลังทำงาน",
        html: "โปรดรอสักครู่...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          this.$store.dispatch("AuthModule/onLoginGoogle", obj).then((res) => {
            if (res.code == 200) {
              Swal.hideLoading();
              Swal.clickConfirm();
              let path = "/";
              if (this.$route.path !== path) this.$router.push(path);
            } else {
              Swal.fire({
                title: res.message ? res.message : "ผิดพลาดไม่สามารถล็อคอินได้",
                icon: "error",
              });
            }
          });
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login_page {
  background-image: url("../assets/images/background/bg_login.svg");
  /* Full height */
  height: auto;
  width: 100%;
  /* Center and scale the image nicely */
  //background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .btn-login {
    background: #db7f50;
    font-weight: bold;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    border: 1px solid #828282;
    box-sizing: border-box;
    border-radius: 25px;
  }

  .rectangle_login {
    margin-left: auto;
    margin-right: auto;
    max-width: 559px;
    max-height: 600px;
    min-height: 300px;

    background: #ffffff;
    opacity: 0.95;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  }
}
</style>
